import styled from 'styled-components';
import { PRIMARY_COLOR, WHITE } from '../appearance/Colors';

export default styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid ${props => props.$isLight ? 'rgba(0, 0, 0, 0.18)' : 'rgba(255, 255, 255, 0.18)'};
    border-radius: 8px;
    padding: 8px 10px;
    background: transparent;
    color: ${props => props.$isLight ? PRIMARY_COLOR : WHITE};
    font-size: 13px;
    font-weight: 600;
    line-height: 18px;
    cursor: pointer;
    transition: background 0.14s ease, border-color 0.14s ease;
    &:hover {
        background: ${props => props.$isLight ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.08)'};
        border-color: ${props => props.$isLight ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.3)'};
    }
`;
